var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ButtonGroup, Checkbox, Divider, FormControlLabel, Grid, TextField, Typography, styled, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { Config } from "../../../api/config";
import { precheckDynamicCheckListFormUrl } from "../../../api/url";
import { ApproveSqaureIcon, ApproveSqaureIconGreen, RejectIcon, RejectSquareIcon } from "../../../assets/images";
import { MuiButton, MuiPopup, MuiStack } from "../../../components";
import { MuiIconButton } from "../../../components/atoms/iconButtonComponent";
import { MuiLoaderButton } from "../../../components/atoms/loaderButton";
import SkeletonLoader from "../../../components/atoms/sketeton";
import { NoRowsOverlay } from "../../../components/molecules/dataGridComponent";
import { EFIChecklistParent, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from "../../../constants";
import { showLoader, showNotification } from "../../../redux/commonSlice";
import { getByIdAPI, getListAPI, setState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { bajajPrimaryBlue } from "../../../theme/palette";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import useAnalyticsEventTracker from "../../../utils/useAnalyticsEventTracker";
var StyledStack = styled(MuiStack, {
    shouldForwardProp: function (prop) { return prop !== "openRejectActions"; }
})(function (_ref) {
    var theme = _ref.theme, openRejectActions = _ref.openRejectActions, isApproved = _ref.isApproved;
    return {
        backgroundColor: openRejectActions ? '#FFF1F0' : isApproved ? '#F6FFED' : 'none',
        border: "1px solid ".concat(openRejectActions ? "#CF1322" : isApproved ? '#52C41A' : "#DEE4EB"),
        borderRadius: '8px'
    };
});
var FinalInspectorDynamicChecklist = function (props) {
    var _documentDetailsGetBy3, _documentDetailsGetBy4;
    var trackButtonClick = useAnalyticsEventTracker("FinalInspectorDynamicChecklist");
    var dynamicFIChecklistMaster = props.dynamicFIChecklistMaster, callApIStatus = props.callApIStatus, paramKey = props.paramKey, parentComponent = props.parentComponent, isViewOnly = props.isViewOnly, jobCardId = props.jobCardId, showOnlyRejectedItems = props.showOnlyRejectedItems;
    var dispatch = useAppDispatch();
    var _a = useState([]), complaintsList = _a[0], setComplaintsList = _a[1];
    var _b = useState(false), isSelectAll = _b[0], setIsSelectAll = _b[1];
    var _c = useState(false), selectMode = _c[0], setSelectMode = _c[1];
    var _d = useState(""), commonRejectionComment = _d[0], setCommonRejectionComment = _d[1];
    var _e = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _e.documentDetailsGetById, FinalInspectionChecklistCount = _e.FinalInspectionChecklistCount, FIChecklistItemChange = _e.FIChecklistItemChange;
    var _f = useState(false), isOpenRejectAllPopup = _f[0], setIsOpenRejectAllPopup = _f[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _g = useState(true), disableSaveButton = _g[0], setDisableSaveButton = _g[1];
    var _h = useState(true), isShowSkeleton = _h[0], setShowSkeleton = _h[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var isInspectionMode = true;
    useEffect(function () {
        var _documentDetailsGetBy;
        if (callApIStatus && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy = documentDetailsGetById.data) !== null && _documentDetailsGetBy !== void 0 && _documentDetailsGetBy.ProductId) {
            var _documentDetailsGetBy2;
            getCheckList(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.ProductId);
        }
    }, [callApIStatus, documentDetailsGetById]);
    var getPrecheckAnswersByModelId = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, answersResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "FinalInspectionCheckList/FICheckList"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && answersResponse.payload.data && answersResponse.payload.data.Options) {
                        return [2 /*return*/, answersResponse.payload.data.Options];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getCheckList = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload$value, _result$payload$value2, requestBody, result, questionsAnswers_1, QuestionsList, AllQuestionsList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "SystemName": paramKey,
                        "ChildId": productId,
                        "ProductId": productId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (!((_result$payload$value = result.payload.value) !== null && _result$payload$value !== void 0 && _result$payload$value.success && (_result$payload$value2 = result.payload.value) !== null && _result$payload$value2 !== void 0 && _result$payload$value2.data)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPrecheckAnswersByModelId()];
                case 2:
                    questionsAnswers_1 = _a.sent();
                    QuestionsList = result.payload.value.data;
                    AllQuestionsList = QuestionsList.map(function (questionGroupItem) {
                        var _questionGroupItem$Qu;
                        var updatedQuestions = questionGroupItem === null || questionGroupItem === void 0 || (_questionGroupItem$Qu = questionGroupItem.Questions) === null || _questionGroupItem$Qu === void 0 ? void 0 : _questionGroupItem$Qu.map(function (questionItem) {
                            var questionAnswerItem = questionsAnswers_1.find(function (item) { return item.QuestionId === questionItem.QuestionId; });
                            return _objectSpread(_objectSpread({}, questionItem), {}, {
                                ResponseValue: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue : '',
                                isAprroved: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue === "true" : false,
                                isRejected: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue === "false" : false,
                                openRejectActions: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue === "false" : false,
                                rejectionComment: questionAnswerItem && questionAnswerItem.Remarks ? questionAnswerItem.Remarks : "",
                                isSelected: false
                            });
                        });
                        var sortQuestionsBySequence = updatedQuestions.sort(function (a, b) {
                            return a.Sequence - b.Sequence;
                        });
                        return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                            Questions: sortQuestionsBySequence
                        });
                    });
                    if (showOnlyRejectedItems) {
                        AllQuestionsList = AllQuestionsList.map(function (QuestionGroupItem) {
                            var RejectedQuestions = QuestionGroupItem.Questions.filter(function (question) { return question.isRejected; });
                            if (RejectedQuestions.length > 0) {
                                return _objectSpread(_objectSpread({}, QuestionGroupItem), {}, {
                                    Questions: RejectedQuestions
                                });
                            }
                            return null; // Skip groups without rejected items
                        }).filter(Boolean); // Remove null groups
                    }
                    setShowSkeleton(false);
                    setComplaintsList(AllQuestionsList);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onClickApproveIcon = function (QuestionGroupItemIndex, QuestionItemIndex) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        var updatedQuestionGrp = updatedComplaintList[QuestionGroupItemIndex];
        var updatedQuestionItem = updatedQuestionGrp.Questions[QuestionItemIndex];
        updatedQuestionItem.isAprroved = true;
        updatedQuestionItem.isRejected = false;
        updatedQuestionItem.openRejectActions = false;
        updatedQuestionItem.rejectionComment = "";
        updatedQuestionGrp.Questions[QuestionItemIndex] = updatedQuestionItem;
        updatedComplaintList[QuestionGroupItemIndex] = updatedQuestionGrp;
        setComplaintsList(updatedComplaintList);
        setDisableSaveButton(false);
    };
    var onClickRejectIcon = function (QuestionGroupItemIndex, QuestionItemIndex) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        var updatedQuestionGrp = updatedComplaintList[QuestionGroupItemIndex];
        var updatedQuestionItem = updatedQuestionGrp.Questions[QuestionItemIndex];
        updatedQuestionItem.isRejected = true;
        updatedQuestionItem.isAprroved = false;
        updatedQuestionItem.openRejectActions = !updatedQuestionItem.openRejectActions;
        updatedQuestionGrp.Questions[QuestionItemIndex] = updatedQuestionItem;
        updatedComplaintList[QuestionGroupItemIndex] = updatedQuestionGrp;
        // updatedComplaintList.map((complaint) => {
        //     if (complaint.QuestionId !== updatedComplaintList[index].QuestionId) {
        //         for (let item of Object.keys(complaint)) {
        //             if (item === 'openRejectActions') {
        //                 complaint.openRejectActions = false
        //             }
        //         }
        //     }
        // })
        setComplaintsList(updatedComplaintList);
        setDisableSaveButton(false);
    };
    var getAllComplaintsStatus = function () {
        var AllQuestions = complaintsList.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
        var approvedComplaints = AllQuestions.filter(function (item) { return item.isAprroved; });
        var rejectedComplaints = AllQuestions.filter(function (item) { return item.isRejected; });
        return {
            isAllApproved: approvedComplaints.length === AllQuestions.length,
            isAllRejected: rejectedComplaints.length === AllQuestions.length
        };
    };
    var handleComplaintData = function (data, QuestionGroupItemIndex, QuestionItemIndex) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        var updatedQuestionGrp = updatedComplaintList[QuestionGroupItemIndex];
        var updatedQuestionItem = updatedQuestionGrp.Questions[QuestionItemIndex];
        updatedQuestionItem.isRejected = true;
        updatedQuestionItem.isAprroved = false;
        updatedQuestionItem.rejectionComment = data.discription;
        updatedQuestionGrp.Questions[QuestionItemIndex] = updatedQuestionItem;
        updatedComplaintList[QuestionGroupItemIndex] = updatedQuestionGrp;
        // updatedComplaintList.map((complaint) => {
        //     if (complaint.QuestionId !== updatedComplaintList[index].QuestionId) {
        //         for (let item of Object.keys(complaint)) {
        //             if (item === 'openRejectActions') {
        //                 complaint.openRejectActions = false
        //             }
        //         }
        //     }
        // })
        setComplaintsList(updatedComplaintList);
        setDisableSaveButton(false);
    };
    var handleApproveAllComplaints = function () {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList.forEach(function (questionGroup) {
            questionGroup.Questions.forEach(function (question) {
                question.isAprroved = true;
                question.isRejected = false;
                question.openRejectActions = false;
                question.rejectionComment = "";
            });
        });
        setComplaintsList(updatedComplaintList);
        setSelectMode(false);
        setDisableSaveButton(false);
    };
    var handleRejectAllComplaints = function () {
        setIsOpenRejectAllPopup(true);
    };
    var handleCloseRejectAllPopup = function () {
        setIsOpenRejectAllPopup(false);
    };
    var handleRejectAllPopupDataRecieved = function () {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList.forEach(function (questionGroup) {
            questionGroup.Questions.forEach(function (question) {
                question.isAprroved = false;
                question.isRejected = true;
                question.openRejectActions = true;
                question.rejectionComment = commonRejectionComment;
            });
        });
        setComplaintsList(updatedComplaintList);
        handleCloseRejectAllPopup();
        setSelectMode(false);
        setDisableSaveButton(false);
    };
    var handleItemCheckboxClick = function (QuestionGroupItemIndex, QuestionItemIndex) {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        var updatedQuestionGrp = updatedComplaintList[QuestionGroupItemIndex];
        var updatedQuestionItem = updatedQuestionGrp.Questions[QuestionItemIndex];
        updatedQuestionItem.isSelected = !updatedQuestionItem.isSelected;
        updatedQuestionGrp.Questions[QuestionItemIndex] = updatedQuestionItem;
        updatedComplaintList[QuestionGroupItemIndex] = updatedQuestionGrp;
        setComplaintsList(updatedComplaintList);
    };
    var handleSelectAllClick = function () {
        var updatedComplaintList = __spreadArray([], complaintsList, true);
        updatedComplaintList.forEach(function (questionGroup) {
            questionGroup.Questions.forEach(function (question) {
                question.isSelected = !isSelectAll;
            });
        });
        setComplaintsList(updatedComplaintList);
        setIsSelectAll(!isSelectAll);
        setSelectMode(!selectMode);
    };
    var getSelectAllStatus = function () {
        var AllQuestions = complaintsList.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
        var selectedComplaints = AllQuestions.filter(function (item) { return item.isSelected; });
        return selectedComplaints.length === AllQuestions.length;
    };
    var saveDynamicChecklistValues = function () { return __awaiter(void 0, void 0, void 0, function () {
        var FilledValues, AllQuestions, _saveFormValuesRespon, requestBody, saveFormValuesResponse, totalCount, approvedCount, rejectedCount, updatedFICounts, updatedCustomeComplaintCount, updatedCustomeComplaintCount, updatedCustomeComplaintCount, updatedFIChecklistChangeDetails, updatedItem, updatedItem, updatedItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "FI_DynamicCheck_Save", undefined);
                    FilledValues = [];
                    AllQuestions = complaintsList.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
                    if (!(AllQuestions && AllQuestions.length > 0)) return [3 /*break*/, 2];
                    AllQuestions.map(function (questionItem) {
                        var checkValue = "";
                        if (questionItem.isRejected && !questionItem.isAprroved) {
                            checkValue = "false";
                        }
                        if (!questionItem.isRejected && questionItem.isAprroved) {
                            checkValue = "true";
                        }
                        FilledValues.push({
                            QuestionId: questionItem.QuestionId,
                            ResponseValue: checkValue,
                            Remarks: questionItem.isRejected ? questionItem.rejectionComment : ""
                        });
                    });
                    requestBody = {
                        "Options": FilledValues,
                        JobCardId: jobCardId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "FinalInspectionCheckList/UpsertFinalInspectionCheckList"),
                            request: requestBody
                        }))];
                case 1:
                    saveFormValuesResponse = _a.sent();
                    if ((_saveFormValuesRespon = saveFormValuesResponse.payload.value) !== null && _saveFormValuesRespon !== void 0 && _saveFormValuesRespon.success) {
                        setDisableSaveButton(true);
                        setCommonRejectionComment("");
                        totalCount = AllQuestions.length;
                        approvedCount = AllQuestions.filter(function (item) { return !item.isRejected && item.isAprroved; }).length;
                        rejectedCount = totalCount - approvedCount;
                        updatedFICounts = _objectSpread({}, FinalInspectionChecklistCount);
                        if (parentComponent === EFIChecklistParent.DynamicChecklist) {
                            updatedCustomeComplaintCount = _objectSpread({}, updatedFICounts.dynamicFIChecklist);
                            updatedCustomeComplaintCount.approvedCount = approvedCount;
                            updatedCustomeComplaintCount.totalCount = totalCount;
                            updatedCustomeComplaintCount.rejectedCount = rejectedCount;
                            updatedFICounts.dynamicFIChecklist = updatedCustomeComplaintCount;
                        }
                        if (parentComponent === EFIChecklistParent.FastnerChecklist) {
                            updatedCustomeComplaintCount = _objectSpread({}, updatedFICounts.fastnerCheklist);
                            updatedCustomeComplaintCount.approvedCount = approvedCount;
                            updatedCustomeComplaintCount.totalCount = totalCount;
                            updatedCustomeComplaintCount.rejectedCount = rejectedCount;
                            updatedFICounts.fastnerCheklist = updatedCustomeComplaintCount;
                        }
                        if (parentComponent === EFIChecklistParent.StaticChecklist) {
                            updatedCustomeComplaintCount = _objectSpread({}, updatedFICounts.staticFIChecklist);
                            updatedCustomeComplaintCount.approvedCount = approvedCount;
                            updatedCustomeComplaintCount.totalCount = totalCount;
                            updatedCustomeComplaintCount.rejectedCount = rejectedCount;
                            updatedFICounts.staticFIChecklist = updatedCustomeComplaintCount;
                        }
                        updatedFIChecklistChangeDetails = _objectSpread({}, FIChecklistItemChange);
                        if (parentComponent === EFIChecklistParent.DynamicChecklist) {
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.dynamicFIChecklist);
                            updatedItem.isItemRejected = rejectedCount > 0;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.dynamicFIChecklist = updatedItem;
                        }
                        if (parentComponent === EFIChecklistParent.FastnerChecklist) {
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.fastnerCheklist);
                            updatedItem.isItemRejected = rejectedCount > 0;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.fastnerCheklist = updatedItem;
                        }
                        if (parentComponent === EFIChecklistParent.StaticChecklist) {
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.staticFIChecklist);
                            updatedItem.isItemRejected = rejectedCount > 0;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.staticFIChecklist = updatedItem;
                        }
                        dispatch(setState({
                            key: "FinalInspectionChecklistCount",
                            value: updatedFICounts
                        }));
                        dispatch(setState({
                            key: "FIChecklistItemChange",
                            value: updatedFIChecklistChangeDetails
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "".concat(parentComponent, " saved successfully"),
                            type: "success"
                        }));
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    // buttonClickSpan.end();
                    // pageLoadSpan.end();
                    // transaction.end();
                    return [2 /*return*/, saveFormValuesResponse];
                case 2: return [2 /*return*/, false];
            }
        });
    }); };
    var getSaveDisable = function () {
        var AllQuestions = complaintsList.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
        return !AllQuestions.every(function (item) { return item.isAprroved || item.isRejected; }) || isViewOnly || disableSaveButton;
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, (complaintsList === null || complaintsList === void 0 ? void 0 : complaintsList.length) > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between'
    }, Module === isModuleConfig.Product && /*#__PURE__*/ React.createElement(ButtonGroup, {
        disabled: isViewOnly,
        variant: "outlined",
        "aria-label": "owener rider button group"
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "medium",
        sx: {
            border: '1px solid #F5222D',
            color: '#F5222D',
            backgroundColor: getAllComplaintsStatus().isAllRejected ? '#F4F7FA' : 'transparent'
        },
        name: t("Reject all"),
        onClick: handleRejectAllComplaints,
        id: "owner-button"
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        size: "medium",
        sx: {
            border: "1px solid ".concat(bajajPrimaryBlue),
            borderLeftColor: '#F5222D',
            color: bajajPrimaryBlue,
            backgroundColor: getAllComplaintsStatus().isAllApproved ? '#F4F7FA' : 'transparent'
        },
        name: t('Approve all'),
        onClick: handleApproveAllComplaints,
        id: "rider-button"
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, complaintsList.map(function (QuestionGroupItem, QuestionGroupItemIndex) {
        return /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            rowSpacing: 2
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h2"
        }, QuestionGroupItem.QuestionGroupName, " ")), QuestionGroupItem.Questions.map(function (QuestionItem, QuestionItemIndex) {
            return /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                key: QuestionItemIndex
            }, /*#__PURE__*/ React.createElement(StyledStack, {
                openRejectActions: QuestionItem.openRejectActions,
                isApproved: QuestionItem.isAprroved,
                paddingY: 1,
                paddingX: 2,
                direction: 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                justifyContent: isInspectionMode ? 'space-between' : 'center',
                alignItems: "center"
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: "StdTitle",
                variant: "h3"
            }, QuestionItem.Title), selectMode ? /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormControlLabel, {
                disabled: isViewOnly,
                control: /*#__PURE__*/ React.createElement(Checkbox, null),
                label: '',
                checked: QuestionItem.isSelected,
                onClick: function () {
                    handleItemCheckboxClick(QuestionGroupItemIndex, QuestionItemIndex);
                },
                sx: {
                    margin: 0
                }
            })) : /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
                size: "small",
                onClick: function () { return onClickApproveIcon(QuestionGroupItemIndex, QuestionItemIndex); },
                disabled: QuestionItem.isAprroved || isViewOnly
            }, /*#__PURE__*/ React.createElement("img", {
                alt: "approve",
                id: "StdApprove",
                src: QuestionItem.isAprroved || isViewOnly ? ApproveSqaureIcon : ApproveSqaureIconGreen
            })), /*#__PURE__*/ React.createElement(MuiIconButton, {
                size: "small",
                onClick: function () { return onClickRejectIcon(QuestionGroupItemIndex, QuestionItemIndex); },
                disabled: QuestionItem.isRejected || isViewOnly
            }, /*#__PURE__*/ React.createElement("img", {
                alt: "reject",
                id: "StdReject",
                src: QuestionItem.isRejected || isViewOnly ? RejectSquareIcon : RejectIcon
            })))), QuestionItem.openRejectActions && /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, QuestionItem.openRejectActions && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                lg: 5.8,
                md: 5.8,
                sm: 5.8,
                xs: 12
            }, /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "14px",
                fontWeight: "600",
                color: '#1B1D21',
                marginTop: '16px'
            }, t('FI Observation')), /*#__PURE__*/ React.createElement(MuiStack, {
                sx: {
                    border: '1px solid #DEE4EB',
                    borderRadius: "8px",
                    padding: '2px',
                    background: '',
                    marginTop: '6px'
                },
                width: "100%",
                bgcolor: 'white'
            }, /*#__PURE__*/ React.createElement(TextField, {
                disabled: isViewOnly,
                tabIndex: 4,
                id: "customerDescription",
                placeholder: "Enter rejection remarks...",
                value: QuestionItem.rejectionComment,
                multiline: true,
                rows: 3,
                variant: "outlined",
                fullWidth: true,
                onChange: function (event) {
                    var _event$target$value, _event$target;
                    handleComplaintData({
                        discription: (_event$target$value = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : ''
                    }, QuestionGroupItemIndex, QuestionItemIndex);
                }
                //  disabled={}
                ,
                sx: {
                    "& fieldset": {
                        border: 'none'
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "#F4F7FA"
                    }
                },
                inputProps: {
                    maxLength: 100
                }
            }))))));
        }));
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        disabled: getSaveDisable(),
        variant: "contained",
        name: t('Save'),
        onClick: saveDynamicChecklistValues
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isShowSkeleton && /*#__PURE__*/ React.createElement(NoRowsOverlay, null)), /*#__PURE__*/ React.createElement(React.Fragment, null, isShowSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '50px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isOpenRejectAllPopup,
        title: parentComponent,
        variant: "h1",
        onClose: handleCloseRejectAllPopup,
        closeIcon: true,
        bgcolor: "pink",
        containerStyle: {
            width: '100%',
            padding: '2px 5px 8px 5px'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 2,
        paddingBottom: 1,
        direction: 'column',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Job card:"), " ", (_documentDetailsGetBy3 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.Code) !== null && _documentDetailsGetBy3 !== void 0 ? _documentDetailsGetBy3 : " -"), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: "8px",
            padding: '2px'
        },
        width: "100%"
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "multiline-input",
        placeholder: "Enter rejection remarks...",
        value: commonRejectionComment,
        multiline: true,
        rows: 2,
        variant: "outlined",
        fullWidth: true,
        onChange: function (event) {
            var _event$target$value2;
            setCommonRejectionComment((_event$target$value2 = event.target.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "");
        },
        sx: {
            "& fieldset": {
                border: 'none'
            }
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        disabled: !commonRejectionComment,
        name: t("Reject all"),
        size: "medium",
        fullWidth: true,
        variant: "contained",
        onClick: handleRejectAllPopupDataRecieved,
        sx: {
            backgroundColor: '#F5222D'
        }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: t('Cancel'),
        size: "medium",
        sx: {
            borderColor: '#DEE4EB',
            color: '#6A7682'
        },
        fullWidth: true,
        onClick: handleCloseRejectAllPopup
    }))))));
};
export default FinalInspectorDynamicChecklist;
